type RouteId = string | number | null | undefined

export const resolveKidId = (path: string, kidId: RouteId): string | null => {
  return !kidId
    ? null
    : path.replace('[kid]', `${kidId}`)
}

export const resolveProgressReportId = (path: string, kidId: RouteId, reportId: RouteId): string | null => {
  if (!kidId) {
    return null
  } else if (!reportId) {
    return null
  } else {
    return path
      .replace('[kid]', `${kidId}`)
      .replace('[report]', `${reportId}`)
  }
}

export const resolveOrderId = (path: string, orderId: RouteId): string | null => {
  return path.replace('[order]', `${orderId}`)
}
